import { takeLatest } from 'redux-saga/effects';

import * as threadActions from '../actions';

import {
    fetchThreadDocumentsSaga,
    fetchInsightsDocumentsSaga,
    fetchPreviewDocumentSaga,
    fetchInsightsListSaga,
    fetchInsightsPreviewDashboardSaga,
    fetchInsightsGraphDashboardSaga,
    updateInsightsNewTagSaga,
} from './thread';

/**
 * Root saga for thread actions
 *
 * @method threadSaga
 * @type   {Generator}
 */
function* threadSaga() {
    yield takeLatest(threadActions.fetchThreadDocuments.TRIGGER, fetchThreadDocumentsSaga);
    yield takeLatest(threadActions.fetchInsightsDocuments.TRIGGER, fetchInsightsDocumentsSaga);
    yield takeLatest(threadActions.fetchPreviewDocument.TRIGGER, fetchPreviewDocumentSaga);
    yield takeLatest(threadActions.fetchInsightsList.TRIGGER, fetchInsightsListSaga);
    yield takeLatest(
        threadActions.fetchInsightsPreviewDashboard.TRIGGER,
        fetchInsightsPreviewDashboardSaga
    );
    yield takeLatest(threadActions.updateInsightsNewTag.TRIGGER, updateInsightsNewTagSaga);
    yield takeLatest(
        threadActions.fetchInsightsGraphDashboard.TRIGGER,
        fetchInsightsGraphDashboardSaga
    );
}

export default threadSaga;

export { fetchThreadDocumentsSaga, fetchInsightsDocumentsSaga };
